import { render, staticRenderFns } from "./LocationsTable.vue?vue&type=template&id=bc759eb2&"
import script from "./LocationsTable.vue?vue&type=script&lang=js&"
export * from "./LocationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports